"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeFormat = void 0;
/**
 * 日期格式(h:mm A - 12小时, H:mm - 24小时)
 */
var TimeFormat;
(function (TimeFormat) {
    TimeFormat["H_MM_A"] = "h:mm A";
    TimeFormat["H_MM"] = "H:mm";
})(TimeFormat = exports.TimeFormat || (exports.TimeFormat = {}));
